import { DefaultIntegrationAPI } from "./base";

export class EmailIntegrationAPI extends DefaultIntegrationAPI {

  async sendTestEmail (email: string, formId: string) {
    return await this.api.post(
      `/v1/integrations/email/trigger-mock-event`, { recipientEmail: email, emailSubject: 'Test Email Integration' }
    )
  }

  async saveEmail (siteId: string, formId: string, email: string) {
    const res = await this.api.post(
      `/v1/sites/${siteId}/${formId}/hookURL?provider=email`, { hookURL: email }
    )
    return res.data
  }

  async getEmail (siteId: string, formId: string) {
    const res = await this.api.get(
      `/v1/sites/${siteId}/${formId}/hookURL?provider=email`,
    )
    return res.data
  }
}
